<div class="ws-time-input-container field-wrapper">
    <label *ngIf="showLabel && label" class="time-label" [for]="'time-input-' + componentId">{{ label }}</label>

    <div class="time-input-wrapper">
        <!-- Single unified time input display -->
        <div class="time-display-input" [class.disabled]="disabled"
            [class.has-value]="hours !== null && minutes !== null" (click)="toggleDropdown()"
            [attr.tabindex]="disabled ? -1 : 0" [attr.aria-expanded]="isDropdownOpen" [attr.aria-haspopup]="true"
            [attr.aria-label]="label || 'Time selector'" (keydown)="onKeyDown($event)">

            <span class="time-value" *ngIf="hours !== null && minutes !== null">
                {{ formatHour(hours) }}:{{ formatMinute(minutes) }}<span *ngIf="!is24HourFormat" class="period">{{
                    period }}</span>
            </span>
            <span class="time-placeholder" *ngIf="hours === null || minutes === null">
                {{ placeholder || 'Select time' |translate}}
            </span>

            <div class="input-actions">
                <!-- Clear button -->
                <mat-icon class="clear-button" *ngIf="hours !== null && minutes !== null && !disabled"
                    (click)="clearTime(); $event.stopPropagation()" [attr.aria-label]="'Clear time'"
                    tabindex="-1">close</mat-icon>

                <!-- Dropdown arrow -->
                <mat-icon class="dropdown-arrow" [class.open]="isDropdownOpen">access_time</mat-icon>
            </div>
        </div>
    </div>
</div>

<!-- Time selection popover template -->
<ng-template #timePopover>
    <div class="time-popover" role="dialog" [attr.aria-label]="'Time selection panel'"
        (keydown)="handlePopoverKeydown($event)" tabindex="0">
        <div class="time-selectors">
            <!-- Hours selection -->
            <div class="time-column">
                <div class="column-header">{{ (is24HourFormat ? 'Hours' : 'Hour') | translate }}</div>
                
                <!-- Custom hour input -->
                <div class="custom-input-wrapper">
                    <input type="number" class="hour-input" [value]="hours || ''" (blur)="onHourInputBlur($event)"
                        (keydown)="onHourInputKeydown($event)" [min]="is24HourFormat ? 0 : 1" 
                        [max]="is24HourFormat ? 23 : 12" placeholder="00" [disabled]="disabled">
                </div>

                <div class="options-list hours-list" #hoursList>
                    <button type="button" *ngFor="let hour of hourOptions; let i = index" class="time-option"
                        [class.selected]="hours === hour" [class.focused]="isOptionFocused('hours', i)"
                        [disabled]="disabled" (click)="selectHour(hour)" [attr.aria-selected]="hours === hour"
                        tabindex="-1">
                        {{ formatHour(hour) }}
                    </button>
                </div>
            </div>

            <!-- Minutes selection -->
            <div class="time-column">
                <div class="column-header">{{ 'Minutes' | translate }}</div>

                <!-- Custom minute input -->
                <div class="custom-input-wrapper">
                    <input type="number" class="minute-input" [value]="minutes || ''" (blur)="onMinuteInputBlur($event)"
                        (keydown)="onMinuteInputKeydown($event)" min="0" max="59" placeholder="00"
                        [disabled]="disabled">
                </div>

                <!-- Quick selection buttons -->
                <div class="options-list minutes-list">
                    <button type="button" *ngFor="let minute of minuteOptions; let i = index" class="time-option"
                        [class.selected]="minutes === minute" [class.focused]="isOptionFocused('minutes', i)"
                        [disabled]="disabled" (click)="selectMinute(minute)" [attr.aria-selected]="minutes === minute"
                        tabindex="-1">
                        {{ formatMinute(minute) }}
                    </button>
                </div>
            </div>

            <!-- AM/PM selection for 12-hour format -->
            <div class="time-column period-column" *ngIf="!is24HourFormat">
                <div class="column-header">{{ 'Period' | translate }}</div>
                <div class="options-list period-list">
                    <button type="button" *ngFor="let p of periodOptions; let i = index"
                        class="time-option period-option" [class.selected]="period === p"
                        [class.focused]="isOptionFocused('period', i)" [disabled]="disabled" (click)="selectPeriod(p)"
                        [attr.aria-selected]="period === p" tabindex="-1">
                        {{ p }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>